import React from 'react';
const noMore = ['No more starting every new lesson from a blank page.', 'No more searching through disconnected training resources.', 'No more struggling to find clear technical diagrams.', 'No more relying entirely on text-heavy explanations.', 'No more preparing every classroom scenario independently.', 'No more teaching without an organized progression.', 'No more evaluating students without a consistent framework.', 'No more wasting valuable preparation time gathering material that could already be organized for you.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-red-50 relative overflow-hidden" data-id="element-110" data-mp="vv9pnj4e9jnj">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-111" data-mp="vwkrhdea4hc0">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-neutral-900 uppercase" data-id="element-112" data-mp="qw6typab0ps8">
          Next Month You Can Still Be Searching for Firefighter Training Material...
          <br data-id="element-113" data-mp="zxxwxmdgmiie" />
          <span className="text-red-700" data-id="element-114" data-mp="zua6wx784e8f">
            Or You Can Have a Complete Visual Training System Ready for Your Next Class.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-neutral-200" data-id="element-115" data-mp="2h4sqykgexxvd">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-116" data-mp="2r1xhsxl7ehii">
              <span className="text-red-700 mt-0.5" aria-hidden="true" data-id="element-117" data-mp="2r38keu2wxj81">
                ▸
              </span>
              <span className="text-neutral-800" data-id="element-118" data-mp="2v1g2bs944qkt">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-neutral-900 mb-2" data-id="element-119" data-mp="300iyen747mgn">
          Fire Service Instructor Atlas Doesn&apos;t Replace Your Professional Experience.
        </p>
        <p className="text-xl text-neutral-800/80 mb-6" data-id="element-120" data-mp="39rvkey68fier">
          It gives you a structured visual reference system designed to help you prepare and teach
          with greater:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-red-700" data-id="element-121" data-mp="3itmro7gf7xaq">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}